import React, { useState } from 'react';
import Img1 from 'assets/images/img1.png';
import { Link } from 'react-router-dom';
import { EditAltIcon, DeleteIcon } from 'cokitchen-icons';
import { GiftCardCategoryType } from 'utils/types';
import { formatTime, getSimpleDateFormat } from 'utils/functions';
import DeleteModal from 'components/base/delete-modal';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';

type CategoryProps = {
  data: GiftCardCategoryType;
  refetch: () => void;
};

const GiftCardCategoriesCard = ({ data, refetch }: CategoryProps) => {
  const [cardHovered, setCardHovered] = useState(false);
  const [showDeleteCategory, setShowDeleteCategory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState('');

  const handleDelete = async () => {
    try {
      setLoading(true);
      await apiService.delete(`vouchers/voucher-categories/${selectedId}`, {
        isInternal: true,
        baseURL: process.env.REACT_APP_ORDER_API
      });
      toast(<ToastMessage type='success' message='Category deleted successfully' />);
      refetch();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setShowDeleteCategory(false);
      setLoading(false);
    }
  };
  return (
    <div
      onMouseEnter={() => setCardHovered(true)}
      onMouseLeave={() => setCardHovered(false)}
      className={`${
        cardHovered ? 'bg-[#F7F7F7]' : 'bg-[#FFFFFF]'
      } relative rounded-lg border border-[#FAFAFA] shadow-[0px_6px_12px_0px_rgba(136,140,145,0.15)] px-5 py-[14px] flex flex-col h-[191px] w-full sm:max-w-[282px]`}>
      <div className='flex space-x-[-13px]'>
        {data?.images.map((item, index) => (
          <img
            key={index}
            src={item.image_url ? item.image_url : Img1}
            alt=''
            className='rounded-full w-[45px] h-[45px] object-cover '
          />
        ))}
      </div>
      <p className='text-[16px] font-medium my-2'>
        {data?.emoji ?? ''} {data?.name}
      </p>
      <p className='text-[#858585] text-xs'>
        Created&nbsp;
        <span className='mr-[4px]'>{getSimpleDateFormat(data.created_at ?? '')},</span>
        <span>{formatTime(new Date(data.created_at ?? ''))}</span>
      </p>
      <Link to={`/giftcards/categories/${data.id}`} className='text-red-4 underline text-sm mt-7'>
        View
      </Link>
      {cardHovered && (
        <div className='flex gap-2 absolute top-[14px] right-5'>
          <Link
            to={`/giftcards/categories/${data.id}?editing=true`}
            className='cursor-pointer bg-[#FAFAFA] border border-[#E8E8E8] w-[30px] h-[30px] rounded-full p-1 flex items-center justify-center'>
            <EditAltIcon className='text-[#858585]' />
          </Link>
          <div
            onClick={() => {
              setShowDeleteCategory(true);
              setSelectedId(data.id);
            }}
            className='cursor-pointer bg-[#FAFAFA] border border-[#E8E8E8] w-[30px] h-[30px] rounded-full p-1 flex items-center justify-center'>
            <DeleteIcon className='text-[#858585]' />
          </div>
        </div>
      )}
      <DeleteModal
        show={showDeleteCategory}
        onClose={() => setShowDeleteCategory(false)}
        title={`Are you sure you want to delete ${data?.emoji ?? ''}${data?.name}`}
        description='This action cannot be undone'
        handleDelete={handleDelete}
        loading={loading}
        type='delete'
      />
    </div>
  );
};

export default GiftCardCategoriesCard;
